module.exports = __webpack_public_path__ + "static/media/rightTri.21d8cd6b.svg";